import type { ReactNode } from "react";
import { Link } from "react-router";
import { BookrLogo } from "@/design/BookrLogo";
import { Card } from "@/design/ui";

/**
 * The shell for auth and onboarding screens (sign-up, log-in, verification,
 * join), ported in R22 T11.
 *
 * The public header is not shown on these focused screens, so the shell carries
 * the brand: a centred Bookr logo above the card. It fills the viewport and
 * centres its content, so a short form sits in the middle of the screen rather
 * than leaving a band of dead space beneath it, and the atmosphere layer runs
 * behind the whole thing.
 *
 * The logo animates once on mount, which is worth keeping: these screens are
 * usually the first thing a new visitor sees. The animation is CSS in the
 * shared stylesheet and collapses under prefers-reduced-motion.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <main className="relative flex min-h-screen grow flex-col items-center justify-center overflow-hidden bg-page px-4 py-10 text-body">
      <div className="mesh" aria-hidden />
      <div className="grid-lines" aria-hidden />

      <div className="relative flex w-full flex-col items-center">
        <Link to="/" aria-label="Bookr home" className="mb-7">
          <BookrLogo size={34} animate />
        </Link>
        <Card>{children}</Card>
      </div>
    </main>
  );
}
